import React from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Modal, Form, Input, Select, Checkbox, notification, Typography, Space, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import request from '../../lib/request';

/** List page only - Profile/ROC/Tax&SI/KYC/ScanNRead all live on CompanyDetailPage now. */
export default function CompaniesPage() {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [form] = Form.useForm();

  const fetchCompanies = () => {
    setLoading(true);
    request
      .get('/companies')
      .then((r) => r.json())
      .then((r) => {
        if (r.status) setData(r.data);
      })
      .finally(() => setLoading(false));
  };

  React.useEffect(fetchCompanies, []);

  const handleCreate = () => {
    form.validateFields().then((values) => {
      request
        .post('/companies', values)
        .then((r) => r.json())
        .then((r) => {
          if (r.status) {
            notification.success({ message: 'Company created' });
            setModalOpen(false);
            fetchCompanies();
          } else {
            notification.error({ message: r.message });
          }
        });
    });
  };

  const columns = [
    { title: 'Name', dataIndex: 'name', render: (v, record) => <Link to={`/companies/${record.id}`}>{v}</Link> },
    { title: 'Registration No.', dataIndex: 'registration_number' },
    { title: 'Group?', dataIndex: 'is_group', render: (v) => (v ? 'Yes' : 'No') },
    {
      title: 'ScanNRead',
      dataIndex: 'scan_n_read_customer_id',
      render: (v) => (v ? <Tag color="blue">Connected</Tag> : <Tag>Not connected</Tag>),
    },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
        <Typography.Title level={4} style={{ margin: 0 }}>
          Companies
        </Typography.Title>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            form.resetFields();
            setModalOpen(true);
          }}
        >
          New Company
        </Button>
      </Space>

      <Table rowKey="id" columns={columns} dataSource={data} loading={loading} />

      <Modal title="New Company" open={modalOpen} onCancel={() => setModalOpen(false)} onOk={handleCreate}>
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="parent_company_id" label="Parent (Group) Company">
            <Select allowClear options={data.filter((c) => c.is_group).map((c) => ({ value: c.id, label: c.name }))} />
          </Form.Item>
          <Form.Item name="is_group" valuePropName="checked">
            <Checkbox>Is a Group Company</Checkbox>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
